<template>
  <div id="home" :class="{ desktop: !mobile, mobile: mobile }">
    <div class="imageSlider"
         @mouseover="stopRotation"
         @mouseout="startRotation">
      <div class="slider-arrow" v-if="!mobile">
        <div class="slider-button" @click="prev">
          <i class="fas fa-angle-left"></i>
        </div>
      </div>
      <v-touch v-on:swipeleft="prev" v-on:swiperight="next">
        <div class="img-wrapper">
          <transition :name="animation" mode="ease-out-in" @after-enter="afterSlide">
            <img :src="currentImage"
                 :key="currentNumber">
          </transition>
        </div>
      </v-touch>
      <div class="slider-arrow" v-if="!mobile">
        <div class="slider-button" @click="next">
          <i class="fas fa-angle-right"></i>
        </div>
      </div>
    </div>
    <p><i>Sessions starting at $100 - Gift certificates available</i></p>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      images: [require('../assets/image_slider/IMG_0001.jpg'),
        require('../assets/image_slider/IMG_0002.jpg'),
        require('../assets/image_slider/IMG_0003.jpg'),
        require('../assets/image_slider/IMG_0004.jpg'),
        require('../assets/image_slider/IMG_0005.jpg'),
        require('../assets/image_slider/IMG_0006.jpg')],
      currentNumber: 0,
      timer: null,
      animation: 'fade',
      mobile: false
    }
  },

  created () {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.mobile = true
      this.images.reverse()
      this.currentNumber = this.images.length - 1
    }
  },

  mounted: function () {
    this.startRotation()
  },

  methods: {
    startRotation: function () {
      if (!this.mobile) {
        this.timer = setInterval(this.next, 8000)
      } else {
        this.timer = setInterval(this.prev, 8000)
      }
    },

    stopRotation: function () {
      clearTimeout(this.timer)
      this.timer = null
    },

    next: function () {
      this.currentNumber += 1
      this.stopRotation()
      this.startRotation()
    },

    prev: function () {
      this.animation = 'fade-reverse'
      if (this.currentNumber === 0) {
        this.currentNumber = this.images.length - 1
      } else {
        this.currentNumber -= 1
      }
      this.stopRotation()
      this.startRotation()
    },

    afterSlide: function () {
      this.animation = 'fade'
    }
  },

  computed: {
    currentImage: function () {
      return this.images[Math.abs(this.currentNumber) % this.images.length]
    }
  }
}
</script>

<style scoped>
.imageSlider {
  width: auto;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.slider-arrow {
  margin: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.slider-button {
  padding: 10px 5px 10px 5px;
  border-radius: 5px;
  font-size: 24px;
  color: #00a7af;
  transition: all 0.5s;
}

.slider-button:hover {
  color: white;
  background-color: #575f60;
  cursor: pointer;
}

#home.desktop .img-wrapper {
  min-width: 600px;
  height: 400px;
}

#home.mobile .img-wrapper {
  height: 250px;
}

#home.desktop img {
  width: 600px;
  height: 400px;
  overflow: hidden;
  transition: all 0.8s;
}

#home.mobile img {
  max-width: 100vw;
  overflow: hidden;
  transition: all 0.8s;
}

.fade-transition {
  transition: all 1s ease;
  visibility: visible;
  overflow: hidden;
  opacity: 1;
  position: absolute;
}

.fade-enter-active{
  opacity: 0;
  transform: translate(-100%, 0);
}

.fade-leave-active{
  opacity: 0;
  transform: translate(100%, 0);
}

.fade-reverse-transition {
  transition: all 1s ease;
  visibility: visible;
  overflow: hidden;
  opacity: 1;
  position: absolute;
}

.fade-reverse-enter-active{
  opacity: 0;
  transform: translate(100%, 0);
}

.fade-reverse-leave-active{
  opacity: 0;
  transform: translate(-100%, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue